import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const MediaLayoutTop = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => {
  return (
    <SvgIcon data-temporary-fix height={height} width={width} {...props}>
      <path
        d="M3.99979 12.6C3.5264 12.6 3.14265 13.0029 3.14265 13.5C3.14265 13.9971 3.5264 14.4 3.99979 14.4H15.9998C16.4732 14.4 16.8569 13.9971 16.8569 13.5C16.8569 13.0029 16.4732 12.6 15.9998 12.6H3.99979Z"
        fill={getColor(color, isColorInherited)}
      />
      <path
        d="M3.99979 16.2C3.5264 16.2 3.14265 16.6029 3.14265 17.1C3.14265 17.5971 3.5264 18 3.99979 18H15.9998C16.4732 18 16.8569 17.5971 16.8569 17.1C16.8569 16.6029 16.4732 16.2 15.9998 16.2H3.99979Z"
        fill={getColor(color, isColorInherited)}
      />
      <path
        d="M3.14265 20.7C3.14265 20.2029 3.5264 19.8 3.99979 19.8H7.99979C8.47318 19.8 8.85693 20.2029 8.85693 20.7C8.85693 21.1971 8.47318 21.6 7.99979 21.6H3.99979C3.5264 21.6 3.14265 21.1971 3.14265 20.7Z"
        fill={getColor(color, isColorInherited)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.856934 2.4C0.856934 1.07452 1.88028 0 3.14265 0H16.8569C18.1193 0 19.1426 1.07452 19.1426 2.4V21.6C19.1426 22.9255 18.1193 24 16.8569 24H3.14265C1.88028 24 0.856934 22.9255 0.856934 21.6V2.4ZM18.5712 10.8H1.42836V21.6C1.42836 22.5941 2.19587 23.4 3.14265 23.4H16.8569C17.8037 23.4 18.5712 22.5941 18.5712 21.6V10.8Z"
        fill={getColor(color, isColorInherited)}
      />
    </SvgIcon>
  );
};
